import gql from 'graphql-tag'

export default gql`
	query getERPShopsWithoutDataStatistics($params: StatisticERPShopsWithoutDataParams!) {
		cashAssist {
			getERPShopsWithoutDataStatistics(params: $params)  {
				number
				name
			}
		}
	}
`
